module.exports = __webpack_public_path__ + "static/img/ic_home_pt_gy_yj.2bf59313.png";